import React from "react";

const CustomerTab = ({ orderData }) => {
    return (
        <div className="p-6">
            <h2 className="text-xl font-bold mb-4">Customer Information</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* Customer Details */}
                <div className="space-y-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Customer Name
                        </label>
                        <div className="p-2 bg-gray-50 rounded border">
                            {orderData.userId?.name || "N/A"}
                        </div>
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Phone Number
                        </label>
                        <div className="p-2 bg-gray-50 rounded border">
                            {orderData.userId?.phoneNumber || "N/A"}
                        </div>
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Email
                        </label>
                        <div className="p-2 bg-gray-50 rounded border">
                            {orderData.userId?.email || "N/A"}
                        </div>
                    </div>
                </div>

                {/* Additional Info */}
                <div className="space-y-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Cashier
                        </label>
                        <div className="p-2 bg-gray-50 rounded border">
                            {orderData.cashier?.name || "N/A"}
                        </div>
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            IC
                        </label>
                        <div className="p-2 bg-gray-50 rounded border">
                            {orderData.userId?.ic || "N/A"}
                        </div>
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            TIN
                        </label>
                        <div className="p-2 bg-gray-50 rounded border">
                            {orderData.userId?.tin || "N/A"}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CustomerTab;
